import { ArrowRight } from "lucide-react";

export function RelationArrow() {
  return (
    <div className="flex items-center justify-center px-4">
      <ArrowRight className="w-6 h-6 text-sidebar-foreground/50" />
    </div>
  );
}